import { isMobile } from "../common/utils";
import Swiper from "swiper";

const initialize = async (sectionData) => {
  const nColumns = sectionData.nColumns;
  const mobile = isMobile();
  const swiper = new Swiper(`#shopify-section-${sectionData.id} .gd-swiper`, {
    slidesPerView: nColumns,
    spaceBetween: 40,
    breakpoints: {
      0: {
        slidesPerView: 1.5,
        slidesOffsetBefore: 32,
        slidesOffsetAfter: 32,
        spaceBetween: 24,
      },
      801: {
        slidesPerView: nColumns,
        spaceBetween: 40,
      },
    },
  });
};

/*
 * main
 */

document.addEventListener("DOMContentLoaded", () => {
  const sectionData = window.kochibin.sections.filter((s) => s.type == "collection-slider");
  sectionData.forEach((sectionData) => initialize(sectionData));
});
